<template>
  <div class="sub-page home-page">
    <div class="sub-topbar">
      <div class="back-btn" @click="back">
        <img width="50" src="../../static/images/back.png"/>
      </div>
      <div class="sub-page-title">{{ $t('select_package') }}</div>
      <div class="sub-topbar-space"></div>
    </div>

    <div class="sub-content">
      <div class="sub-card" @click="goSub('daily')">
        <div class="sub-left">
          <img src="/static/images/sub_logo.png" class="sub-icon"/>
        </div>
        <div class="sub-center">
          <div class="sub-title">{{ $t('daily_package') }}</div>
          <div class="sub-desc">{{ $t('chances_2_day') }}</div>
          <div class="sub-desc">{{ $t('chances_2_day_Validity') }}</div>
          <div class="sub-desc sub-highlight">{{ $t('free_first_sub') }}</div>
        </div>
        <div class="sub-right">
          <div class="sub-price">$0.10</div>
          <button class="sub-btn">{{ $t('Register') }}</button>
        </div>
      </div>

      <div class="sub-card" @click="goSub('weekly')">
        <div class="sub-left">
          <img src="/static/images/sub_logo.png" class="sub-icon"/>
        </div>
        <div class="sub-center">
          <div class="sub-title">{{ $t('weekly_package') }}</div>
          <div class="sub-desc">{{ $t('chances_14_day') }}</div>
          <div class="sub-desc">{{ $t('chances_14_day_Validity') }}</div>
        </div>
        <div class="sub-right">
          <div class="sub-price">$0.60</div>
          <button class="sub-btn">{{ $t('Register') }}</button>
        </div>
      </div>
    </div>

    <!-- OTP确认弹窗 -->
    <div class="modal" v-show="showOtp">
      <div class="modal-bg" @click="closeOtp"></div>
      <div class="otp-modal">
        <div class="otp-modal-header">
          <div class="otp-modal-title">{{ $t('otp_confirm_title') }}</div>
          <div class="otp-modal-close" @click="closeOtp">×</div>
        </div>

        <!-- 订阅包内容 -->
        <div class="otp-package">
          <img src="/static/images/sub_logo.png" class="otp-package-icon"/>
          <div class="otp-package-info">
            <div class="otp-package-name">{{ currentPackage.title }}</div>
            <div class="otp-package-desc">{{ currentPackage.desc }}</div>
            <div class="otp-package-desc">{{ currentPackage.validity }}</div>
          </div>
          <div class="otp-package-price">{{ currentPackage.price }}0</div>
        </div>

        <div class="otp-field">
          <div class="otp-label">{{ $t('phoneNumber') }}</div>
          <div class="otp-control otp-control--readonly">
            <input class="input" :value="mobile" disabled aria-label="Phone number">
          </div>
        </div>

        <div class="otp-field">
          <div class="otp-label">OTP</div>
          <div class="otp-code-row">
            <div class="otp-control">
              <input class="input" v-model="otp" maxlength="6" type="tel" inputmode="numeric"
                     pattern="[0-9]*" @input="handleOtpInput" aria-label="OTP">
            </div>
            <button class="otp-send-button" :class="{ disable: codeText != $t('Subscribe') }" type="button"
                    :disabled="codeText != $t('Subscribe')" @click="userActive">{{ codeText }}</button>
          </div>
        </div>

        <div class="otp-modal-footer">
<!--          <button class="otp-btn otp-btn-cancel" type="button" @click="closeOtp">{{ $t('cancel') }}</button>-->
          <button class="otp-btn otp-btn-confirm" type="button" @click="userConfirm">{{ $t('confirm') }}</button>
        </div>

        <div class="ac otp-esim-row">
          <div class="otp-esim-text">
            <span>{{ $t('need_esim_prefix') }}</span>
            <span class="otp-esim-link" @click="goBuyESim">{{ $t('get_esim') }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mobile: '',
      type: '',
      channel: '',
      otp: '',
      codeText: '',
      isSending: false,
      showOtp: false,
      timer: '',
      currentPackage: {}
    }
  },
  created() {
    this.codeText = this.$t('Subscribe');
    if(this.$route.query.mobile){
      this.mobile = this.$route.query.mobile;
    }
    if(this.$route.query.channel){
      this.channel = this.$route.query.channel;
    }
    this.sendReport();
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    goBuyESim() {
      window.location.href = 'https://selfcareapp-links.cellcard.com.kh/?redirectTo=main/buyESim';
    },
    goSub(type) {
      let that = this;
      if (!that.mobile) {
        that.$utils.alertText(that.$t('loginTips'), 80);
        return;
      }
      that.type = type;
      that.currentPackage = that.getPackageInfo(type);
      that.otp = '';
      // 打开otp弹窗并发送otp
      that.showOtp = true;
      that.userActive();
    },
    userActive() {
      let that = this
      if (!that.mobile) {
        that.$utils.alertText(that.$t('loginTips'),80)
        return;
      }
      if (that.isSending) {
        return;
      }
      that.isSending = true;
      let data = {
        'mobile': that.mobile,
        'type': that.type,
        'channel': that.channel,
      }
      that.$parent.loadModal(true);
      that.$api.post('/api/user/active', data, r => {
        that.$parent.loadModal(false);
        that.isSending = false;
        that.$utils.alertText(r.msg, 80);
        if (r.code == 1) {
          // 发送成功，开始倒计时
          that.countDown(301, 1);
        }
      })
    },
    userConfirm() {
      let that = this
      if (!that.mobile) {
        that.$utils.alertText(that.$t('loginTips'),80)
        return;
      }
      if (that.otp == '') {
        that.$utils.alertText(that.$t('otpTips'), 60)
        return;
      }
      let data = {
        'mobile': that.mobile,
        'otp': that.otp,
        'type': that.type,
        'channel': that.channel,
      }
      that.$parent.loadModal(true);
      that.$api.post('/api/user/confirm', data, r => {
        that.$parent.loadModal(false);
        that.$utils.alertText(r.msg, 80);
        if (r.code == 1) {
          // 订阅成功，关闭弹窗并进入app
          that.closeOtp();
          let token = r.data.userinfo.token;
          let mobile = r.data.userinfo.mobile;
          localStorage.setItem('token', token);
          localStorage.setItem('mobile', mobile);
          window.location.href = '/app';
        }
      })
    },
    sendReport(){
      let that = this
      let data = {
        'mobile': that.mobile,
        'channel': that.channel,
        'type': "sub",
      }
      that.$api.post('/api/land/config', data, r => {

      })
    },
    closeOtp() {
      let that = this;
      that.showOtp = false;
      that.otp = '';
    },
    handleOtpInput(event) {
      this.otp = event.target.value.replace(/[^0-9]/g, '');
    },
    // 获取订阅包信息
    getPackageInfo(type) {
      let info = {};
      if (type == 'daily') {
        info.title = this.$t('daily_package');
        info.desc = this.$t('chances_2_day');
        info.validity = this.$t('chances_2_day_Validity');
        info.price = '$0.1';
      } else if (type == 'weekly') {
        info.title = this.$t('weekly_package');
        info.desc = this.$t('chances_14_day');
        info.validity = this.$t('chances_14_day_Validity');
        info.price = '$0.6';
      }
      return info;
    },
    // 倒计时
    countDown(miao, type) {
      if (miao === 1) {
        this.codeText = this.$t('Subscribe');
        return;
      }
      miao--;
      if (type === 1) {
        this.codeText = miao + "s";
        this.isReturn = false;
      }
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.countDown(miao, type);
      }, 1000)
    },
  }
}
</script>

<style scoped>
.sub-page {
  min-height: 100vh;
  padding: clamp(12px, 2.7vw, 20px) clamp(14px, 3.2vw, 24px) clamp(28px, 6.4vw, 48px);
  max-width: 750px;
  margin: 0 auto;
}

.sub-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: clamp(18px, 4vw, 30px);
}

.back-btn {
  width: clamp(36px, 8.9vw, 48px);
  height: clamp(36px, 8.9vw, 48px);
  display: flex;
  align-items: center;
  justify-content: center;
}

.back-btn img {
  width: clamp(24px, 6.2vw, 36px);
}

.sub-page-title {
  flex: 1;
  text-align: center;
  color: #fff;
  font-size: clamp(16px, 4vw, 28px);
  font-weight: 700;
  white-space: nowrap;
}

.sub-topbar-space {
  width: clamp(36px, 8.9vw, 48px);
}

.sub-content {
  padding-top: clamp(6px, 1.3vw, 10px);
}

.sub-card {
  display: flex;
  align-items: center;
  background: #0542b5;
  border: 2px solid rgba(255, 255, 255, 0.08);
  border-radius: clamp(14px, 3.2vw, 24px);
  padding: clamp(14px, 3.2vw, 24px);
  margin-bottom: clamp(14px, 3.2vw, 24px);
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.35);
}

.sub-left {
  margin-right: clamp(12px, 2.7vw, 20px);
}

.sub-icon {
  width: clamp(50px, 11.2vw, 84px);
  height: clamp(50px, 11.2vw, 84px);
  border-radius: clamp(12px, 2.7vw, 20px);
  display: block;
}

.sub-center {
  flex: 1;
  min-width: 0;
}

.sub-title {
  font-size: clamp(18px, 4vw, 30px);
  font-weight: 700;
  color: #fff;
  line-height: 1.3;
}

.sub-desc {
  font-size: clamp(13px, 2.9vw, 22px);
  color: #ddd;
  line-height: 1.5;
  margin-top: clamp(4px, 1.1vw, 8px);
}

.sub-highlight {
  color: rgb(248, 180, 217);
}

.sub-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-left: clamp(10px, 2.1vw, 16px);
  min-width: clamp(86px, 17.6vw, 132px);
}

.sub-price {
  font-size: clamp(20px, 4.5vw, 34px);
  font-weight: 700;
  color: #ffcc33;
  margin-bottom: clamp(10px, 2.4vw, 18px);
}

.sub-btn {
  min-width: clamp(76px, 16vw, 120px);
  height: clamp(36px, 7.5vw, 56px);
  padding: 0 clamp(12px, 2.9vw, 22px);
  border-radius: 28px;
  border: none;
  background: #f5b400;
  color: #000;
  font-size: clamp(13px, 2.9vw, 22px);
  font-weight: 700;
}

@media (max-width: 420px) {
  .sub-card {
    align-items: flex-start;
  }

  .sub-right {
    min-width: 82px;
  }
}

/* OTP弹窗 */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
}

.modal-bg {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
}

.otp-modal {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: min(560px, 88vw);
  max-height: 90vh;
  overflow-y: auto;
  background: #0b3fa0;
  border: 2px solid rgba(255, 255, 255, 0.15);
  border-radius: clamp(14px, 3.2vw, 24px);
  padding: clamp(16px, 3.6vw, 28px);
  box-sizing: border-box;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.5);
}

.otp-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: clamp(12px, 2.7vw, 20px);
}

.otp-modal-title {
  color: #fff;
  font-size: clamp(17px, 3.8vw, 28px);
  font-weight: 700;
}

.otp-modal-close {
  width: clamp(28px, 6.2vw, 40px);
  height: clamp(28px, 6.2vw, 40px);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
  color: #fff;
  font-size: clamp(18px, 4vw, 26px);
  line-height: 1;
}

.otp-package {
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: clamp(10px, 2.2vw, 16px);
  padding: clamp(10px, 2.2vw, 16px);
  margin-bottom: clamp(14px, 3.2vw, 22px);
}

.otp-package-icon {
  width: clamp(42px, 9.4vw, 64px);
  height: clamp(42px, 9.4vw, 64px);
  border-radius: clamp(8px, 1.8vw, 14px);
  margin-right: clamp(10px, 2.2vw, 16px);
  flex-shrink: 0;
}

.otp-package-info {
  flex: 1;
  min-width: 0;
}

.otp-package-name {
  color: #ffcc33;
  font-size: clamp(16px, 3.6vw, 26px);
  font-weight: 700;
  line-height: 1.3;
}

.otp-package-desc {
  color: #ddd;
  font-size: clamp(12px, 2.7vw, 20px);
  line-height: 1.4;
  margin-top: clamp(2px, 0.7vw, 5px);
}

.otp-package-price {
  color: #ffcc33;
  font-size: clamp(18px, 4vw, 30px);
  font-weight: 700;
  margin-left: clamp(8px, 1.8vw, 14px);
  flex-shrink: 0;
}

.otp-field + .otp-field {
  margin-top: clamp(12px, 2.7vw, 20px);
}

.otp-label {
  color: #fff;
  font-size: clamp(13px, 2.9vw, 22px);
  font-weight: 700;
  margin: 0 0 clamp(4px, 1.1vw, 8px);
  text-align: left;
}

.otp-control {
  align-items: center;
  background: rgba(255, 255, 255, 0.88);
  border: 2px solid #fff;
  border-radius: 999px;
  display: flex;
  height: clamp(42px, 8.9vw, 64px);
  min-width: 0;
  overflow: hidden;
  width: 100%;
}

.otp-control--readonly {
  background: rgba(230, 241, 255, 0.92);
}

.otp-control .input {
  color: #10215e;
  font-size: clamp(16px, 3.6vw, 26px);
  height: 100%;
  line-height: 1;
  margin: 0;
  padding: 0 clamp(14px, 3vw, 22px);
}

.otp-code-row {
  align-items: stretch;
  display: flex;
  gap: clamp(8px, 1.6vw, 12px);
}

.otp-code-row .otp-control {
  flex: 1;
}

.otp-send-button {
  background: #1948ba;
  border: 2px solid #fff;
  border-radius: 999px;
  color: #fff;
  flex: 0 0 clamp(96px, 22vw, 160px);
  font-size: clamp(13px, 2.9vw, 22px);
  font-weight: 700;
  padding: 0 clamp(8px, 1.6vw, 12px);
}

.otp-send-button:disabled {
  background: #6f83b6;
  color: rgba(255, 255, 255, 0.82);
}

.otp-modal-footer {
  display: flex;
  gap: clamp(10px, 2.2vw, 16px);
  margin-top: clamp(18px, 4vw, 30px);
}

.otp-btn {
  flex: 1;
  height: clamp(42px, 8.9vw, 64px);
  border: none;
  border-radius: 999px;
  font-size: clamp(15px, 3.4vw, 24px);
  font-weight: 700;
}

.otp-btn-cancel {
  background: rgba(255, 255, 255, 0.18);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.35);
}

.otp-btn-confirm {
  background: #f5b400;
  color: #000;
}

.otp-esim-row {
  margin-top: clamp(8px, 1.8vw, 14px);
  text-align: center;
}

.otp-esim-text {
  align-items: center;
  background: rgba(4, 35, 111, 0.84);
  border: 1px solid rgba(255, 255, 255, 0.72);
  border-radius: 999px;
  box-shadow: 0 2px 5px rgba(0, 23, 82, 0.45);
  color: #fff;
  display: inline-flex;
  font-size: clamp(11px, 2.5vw, 18px);
  gap: 0.1em;
  justify-content: center;
  line-height: 1.5;
  max-width: 100%;
  min-height: clamp(32px, 7.5vw, 52px);
  text-align: center;
  padding: clamp(4px, 1vw, 8px) clamp(8px, 1.6vw, 12px);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.55);
  white-space: nowrap;
  width: 100%;
  font-weight: 600;
}

.otp-esim-link {
  color: #ffd95a;
  text-decoration: underline;
  text-underline-offset: 2px;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/page/sub.vue